import script from "./Catalog.vue?vue&type=script&lang=ts&setup=true"
export * from "./Catalog.vue?vue&type=script&lang=ts&setup=true"

import "./Catalog.vue?vue&type=style&index=0&id=48c4c2e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c4c2e4"]])

export default __exports__